export function ResizeGrip({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.95367 0.147863C9.14696 -0.0492505 9.46063 -0.0493251 9.65387 0.147863C9.8469 0.344958 9.8467 0.664507 9.65387 0.861731L0.845276 9.85099C0.652045 10.048 0.338319 10.048 0.145081 9.85099C-0.0481976 9.65376 -0.0481976 9.33337 0.145081 9.13614L8.95367 0.147863ZM9.15582 3.35197C9.34913 3.15513 9.66183 3.15497 9.85504 3.35197C10.0483 3.54909 10.0481 3.86862 9.85504 4.06583L4.18512 9.85099C3.99192 10.0481 3.67826 10.0478 3.48492 9.85099C3.29161 9.65379 3.29161 9.33334 3.48492 9.13614L9.15582 3.35197Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
}
